<template>
    <v-lazy><div class="section fade-in grey-card">
      <v-container class="px-10" fluid>
      <v-row justify="center">
          <v-col xl="5" lg="6" md="6" cols="12">
          <v-img
          src="../assets/img/chat-inbox.png"
          class="mx-auto"
          max-width="800"
          contain/>
        </v-col>
        <v-col xl="5" lg="6" md="6" cols="12">
          <h2 class="section__header-title mb-15">Scalable & Customisable Chat Experience</h2>
              <v-row>
                  <v-col>
                      <v-card class="mb-8 fill-height">
                          <v-card-title>Brandable Widget</v-card-title>
                          <v-card-text>Tailor colors, welcome messages, and position to match your brand.</v-card-text>
                      </v-card>
                  </v-col>
                  <v-col>
                      <v-card class="mb-8 fill-height">
                          <v-card-title>Human or Automated</v-card-title>
                          <v-card-text>Transition smoothly between bots and agents.</v-card-text>
                      </v-card>
                  </v-col>
              </v-row>
              <v-row>
                  <v-col>
                      <v-card class="mb-8 fill-height">
                          <v-card-title>Compliance & Reporting</v-card-title>
                          <v-card-text>Capture transcripts, tags, and translation data for insights and auditing.
                              </v-card-text>
                      </v-card>
                  </v-col>
                  <v-col>
                      <v-card class="mb-8 fill-height">
                          <v-card-title>Account Management</v-card-title>
                          <v-card-text>Allow customers to manage their accounts, view balances and make payments.</v-card-text>
                      </v-card>
                  </v-col>
              </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div></v-lazy>
</template>
<script>
export default {
    name: 'ChatScalable',
}
</script>

<style lang="scss">

.timeline-container {
  position: relative; 
  height: 10em;
}
.timeline-content {
  height: 100%; 
  align-items: center;
}

.under-img {
  position: absolute;
  left: 7em;
  top: 0;
  z-index: -1;
}

</style>